import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import CTLBaseForm from "application/components/CTLBaseForm";
import CTLNotification from "application/components/CTLNotification";
import { getColumns, Attributes, operationURLS } from "./model";
import { application } from "globals/endpoints";

function dialCodeList({ onLoad, pageName }) {
  const [formData, setFormData] = useState({});
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  function fetchList() {
    const payload = {
      currentPage: 0,
      pageSize: 10,
      sortDirection: "desc",
      sortBy: "id",
      search: "",
      sortDataType: "integer",
      advancedFilters: [],
    };
    application
      .post(operationURLS.list, payload)
      .then((response) => {
        setFormData(response?.data?.data?.currentPageData[0] || {});
      })
      .catch((error) => {
        setFormData([]);
        setNotify({
          isOpen: true,
          message: "",
          type: "error",
          pagename: pageName,
          status: error.response.data.messageDetail || "Error fetching list",
        });
      });
  }

  useEffect(() => {
    fetchList();
  }, []);

  function onSaveForm(data) {
    if (data.id) {
      application
        .post(operationURLS.update, data)
        .then((response) => {
          setNotify({
            isOpen: true,
            message: "",
            type: "success",
            pagename: pageName,
            status: response.data.messageDetail,
          });
          fetchList();
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: "",
            type: "error",
            pagename: pageName,
            status: error.response.data.messageDetail || "Error updating data",
          });
        });
    }
  }

  return (
    <MDBox>
      {formData && (
        <CTLBaseForm
          enableActionButtons={true}
          entityName={pageName}
          columns={getColumns()}
          openForm={true}
          onSaveForm={onSaveForm}
          formData={formData}
          onCloseForm={null}
          formAttributes={Attributes}
        />
      )}
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default dialCodeList;
